var _rect, _rect2, _rect3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.945312,
    y: 1.32764,
    width: 14.1503,
    height: 2.39228,
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 0.0205078,
    y: 0.402344,
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.591797,
    y: 0.973633,
    width: 14.8571,
    height: 14.8571,
    rx: 1,
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07729 2.7454C2.39288 2.7454 2.64872 2.48956 2.64872 2.17397C2.64872 1.85838 2.39288 1.60254 2.07729 1.60254C1.7617 1.60254 1.50586 1.85838 1.50586 2.17397C1.50586 2.48956 1.7617 2.7454 2.07729 2.7454Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36342 2.7454C4.67901 2.7454 4.93485 2.48956 4.93485 2.17397C4.93485 1.85838 4.67901 1.60254 4.36342 1.60254C4.04783 1.60254 3.79199 1.85838 3.79199 2.17397C3.79199 2.48956 4.04783 2.7454 4.36342 2.7454Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64858 2.7454C6.96417 2.7454 7.22001 2.48956 7.22001 2.17397C7.22001 1.85838 6.96417 1.60254 6.64858 1.60254C6.33299 1.60254 6.07715 1.85838 6.07715 2.17397C6.07715 2.48956 6.33299 2.7454 6.64858 2.7454Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCalendar);
export default __webpack_public_path__ + "static/media/card-calendar.dbd559a5844f3b87b2bfac7ddf6fcd4f.svg";
export { ForwardRef as ReactComponent };